var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',[_c('div',{staticClass:"skinTest"},[_c('img',{attrs:{"src":require("../../assets/images/close1.png")},on:{"click":_vm.close}}),_vm._v(" "),_c('img',{attrs:{"src":require("../../../static/images/advertisingSpace.png")},on:{"click":_vm.goSkin}}),_vm._v(" "),_c('span',{on:{"click":_vm.goSkin}})])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04abc37a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/advertisingSpace.vue
// module id = null
// module chunks = 